import { render, staticRenderFns } from "./SocialProof.vue?vue&type=template&id=3786c478&"
import script from "./SocialProof.vue?vue&type=script&lang=js&"
export * from "./SocialProof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports